import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as backpackActions from '../actions/backpack-actions.js';
import './BackpackPreviewer.css';

import api from '../utils/api.js';
import { BackpackFileTypes, fileType } from '../utils/file-type.js';
import LoadingSpinner from './LoadingSpinner.js';
import VideoPlayer from './VideoPlayer.js';

class BackpackPreviewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      item: null,
      previewBlob: null,
      previewUrl: null
    };
  }

  componentDidMount() {
    const { id } = this.props.params;
    const { backpack } = this.props;

    // Grab the backpack file from the backpack reducer store and save it in the
    // previewer state.
    let results = backpack.items.filter((i) => `${i.id}` === `${id}`);
    let item = results[0];

    // Fetch the full item URL, and then cache the file data as a JS blob.
    api(`/files/${id}/url`, {
      headers: { 'Authorization': `JWT ${this.props.session.token}` }
    }).then((payload) => fetch(payload.url))
    .then((fileData) => fileData.blob())
    .then((file) => {
      // Create a JS object URL for the blob.
      let fileUrl = URL.createObjectURL(file);

      // Mark the loading as complete, and cache the preview blob and created URL.
      this.setState({
        item,
        loading: false,
        previewBlob: file,
        previewUrl: fileUrl
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { id } = nextProps.params || this.props.params;
    const { backpack } = nextProps || this.props;

    // Grab the backpack file from the backpack reducer store and save it in the
    // previewer state.
    let results = backpack.items.filter((i) => `${i.id}` === `${id}`);
    let item = results[0];

    this.setState({ item });
   }

  closePreviewer = () => {
    browserHistory.push('/app/backpack');
  }

  /**
   * Method to save the file from the Backpack. Called on click of "Save" in
   * the previewer. Creates an anchor that uses the download property to set the filename
   * before saving, and then triggers a click event on the anchor. Then, removes the anchor.
   *
   * @memberof BackpackPreviewer
   */
  saveFile = () => {
    const { item, previewUrl } = this.state;

    // Create a hidden anchor tag for downloading the file, using the `download`
    // property to set the filename.
    let anchor = document.createElement('a');
    document.body.appendChild(anchor);
    anchor.style = 'display: none';
    anchor.href = previewUrl;
    anchor.download = item.name;
    anchor.click();

    // Now that we're done downloading, remove the anchor.
    anchor.parentNode.removeChild(anchor);
  }

  deleteFile = () => {
    let message = `Are you sure you want to delete this file from your backpack? This can't be undone!`;

    // If the user doesn't confirm the deletion, return early.
    if (!confirm(message)) {
      return;
    }

    const { deleteBackpackItem } = this.props.backpackActions;
    const { id } = this.props.params;
    deleteBackpackItem(id);
    this.closePreviewer();
  }

  /**
   * Render the previewer with the given item from the files API and
   * preview URL. Checks the filetype for the item and renders the appropriate previewer.
   *
   * @memberof BackpackPreviewer
   */
  renderPreview = (item, url) => {
    let { name } = item;
    let filetype = fileType(name);
    let preview;

    switch (filetype) {
      case BackpackFileTypes.Photo:
        preview = (<div className="BackpackPreviewer__photo">
          <img src={url} />
        </div>);
        break;
      case BackpackFileTypes.Video:
        preview = (<div className="BackpackPreview__video">
          <VideoPlayer videoUrl={url} />
        </div>);
      default:
        break;
    }

    return preview;
  }

  /**
   * Render the metadata section of the previewer. Right now just has two buttons for saving and
   * deleting the file from the backpack.
   *
   * @memberof BackpackPreviewer
   */
  renderMetadata = (item, previewUrl) => {
    return (<div className="BackpackPreviewer__metadata">
      <div className="BackpackPreviewer__metainfo"></div>
      <div className="BackpackPreviewer__controls">
        <button className="BackpackPreviewer__control-button" onClick={this.saveFile}>Export</button>
        <button className="BackpackPreviewer__control-button" onClick={this.deleteFile}>Delete</button>
      </div>
    </div>);
  }

  /**
   * Final render loop for the previewer. Either render out the loading spinner, or render the
   * previewer if we have a proper previewer for the file type.
   *
   * @returns
   * @memberof BackpackPreviewer
   */
  render() {
    // Grab the backpack file from the backpack reducer store and save it in the
    // previewer state.
    const { id } = this.props.params;
    let results = this.props.backpack.items.filter((i) => `${i.id}` === `${id}`);
    let item = results[0];

    let { loading, previewUrl } = this.state;

    let preview, metadata;
    if (loading || !item) {
      preview = <LoadingSpinner />;
    } else if (item && previewUrl) {
      preview = this.renderPreview(item, previewUrl);
      metadata = this.renderMetadata(item, previewUrl);
    }

    return (
      <div className="BackpackPreviewerWrap">
        <a className="BackpackPreviewer__close" onClick={this.closePreviewer}><svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M2.18 0L0 2.18l4.54 4.54L0 11.26l2.18 2.18L6.72 8.9l4.56 4.56 2.18-2.18L8.9 6.72l4.56-4.54L11.28 0 6.72 4.54z" fill="#FFF" fillRule="evenodd"/></svg></a>

        {preview}
        {metadata}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    backpack: state.backpack,
    session: state.session
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    backpackActions: bindActionCreators(backpackActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BackpackPreviewer);



// WEBPACK FOOTER //
// ./src/components/BackpackPreviewer.js